import styled from 'styled-components';

export default styled.div`
  cursor: pointer;
  border-bottom: 1px solid #999;
  padding: 5px;
  transition: 0.3s ease-in-out;
  text-align: left;
  &:hover {
    background: #f1f1f1;
  }
`;
